// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calendar-container .vc-title{text-transform:uppercase}.agendamento .form-select-dropdown{max-height:242px}", ""]);
// Exports
module.exports = exports;
